import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { resources } from './utils/resources'

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'ja',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      wait: true,
    },
    resources: resources,
  })

export default i18n
